import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProcurementHeroComponent } from '../../Components/Procurement/procurement-hero/procurement-hero';
import { ProcurementOverviewComponent } from '../../Components/Procurement/procurement-overview/procurement-overview';
import { ProcurementFeaturesComponent } from '../../Components/Procurement/procurement-features/procurement-features';
import { SeoService } from '../../Shared/seo/seo.service';

@Component({
  selector: 'app-procurement-page',
  standalone: true,
  imports: [CommonModule, ProcurementHeroComponent, ProcurementOverviewComponent, ProcurementFeaturesComponent],
  templateUrl: './procurement-page.html',
  styleUrls: ['./procurement-page.css'],
})
export class ProcurementPageComponent implements OnInit {
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.update({
      title: 'Procurement Management Software',
      description:
        'Vendors, purchase requisitions, purchase orders, goods receipts, vendor bills, and approval workflows — orderYaa Procurement keeps every purchase tracked from request to payment.',
      path: '/procurement',
    });
  }
}
